var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { httpRequest } from './httpRequest';
export function fetchAnythingScs(requestUrl, apiKey, options, logger) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!apiKey) {
            logger === null || logger === void 0 ? void 0 : logger.warn('mandatory apiKey is missing!');
        }
        const { headers = {} } = options !== null && options !== void 0 ? options : {};
        const response = yield httpRequest(requestUrl, Object.assign(Object.assign({}, options), { headers: Object.assign(Object.assign({}, headers), { Token: apiKey }) }));
        return response.parsedBody;
    });
}
export const fetchVehicleRaw = (vehicleRequestUrl, apiKey) => __awaiter(void 0, void 0, void 0, function* () {
    return fetchAnythingScs(vehicleRequestUrl, apiKey);
});
export const fetchMatches = (matchingRequestUrl, apiKey) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetchAnythingScs(matchingRequestUrl, apiKey);
    return {
        matches: response.vehicleBasic,
        matchingScores: response.debug.finalScores,
        filterExpression: response.filterExpression,
    };
});
export const fetchCompare = (compareRequestUrl, apiKey) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!compareRequestUrl) {
        throw new Error('no valid url for compare request');
    }
    const compareDataRaw = yield fetchAnythingScs(compareRequestUrl, apiKey);
    if (!((_a = compareDataRaw === null || compareDataRaw === void 0 ? void 0 : compareDataRaw.basic[0]) === null || _a === void 0 ? void 0 : _a.title) || !((_b = compareDataRaw === null || compareDataRaw === void 0 ? void 0 : compareDataRaw.basic[1]) === null || _b === void 0 ? void 0 : _b.title)) {
        throw new Error('no valid cars for compare found');
    }
    return compareDataRaw;
});
